import { Component, OnInit, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { Input } from '@angular/core';
import { Output, EventEmitter } from '@angular/core';
import { HelperService } from '../../../../services/helper/helper.service';
import { ControlBaseComponent } from '../control/control.component';
import { Validators, FormControl } from '@angular/forms';

@Component({
  selector: 'app-control-telephone-input',
  styleUrls: ['./control-telephone-input.component.scss'],
  templateUrl: './control-telephone-input.component.html',
})
export class ControlTextTelephoneComponent extends ControlBaseComponent implements OnChanges, OnInit {

  @Input() isDisabled: boolean = false;
  @Input() isRequired: boolean;
  @Input() minLength: number = null;
  @Input() maxLength: number = null;
  @Input() placeholder: string;
  @Input() label: string;
  @Input() model: any;
  @Input() bindValue: string;
  @Input() cssClass: string;
  @Input() controlName: any;
  @Input() isLandlinePhone: boolean;
  @Input() inlineControl = false;
  @Output() ngModelChange = new EventEmitter();
  @Output() ngValidationError = new EventEmitter();

  constructor(public helperService: HelperService,
    private changeDetection: ChangeDetectorRef) {
    super(helperService);
  }

  ngOnInit(): void {
    if (this.isLandlinePhone) {
      this.phoneMask = '(00) 00-000-00';
    }
    else {
      this.phoneMask = '000-000-000';
    }
  }


  private SearchTimeout;

  private searchDelay = true;

  public phoneMask = '000-000-000';

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.maxLength) {
      this.maxLength = 1024;
    }
  }

  onKeyUp() {
    if (this.SearchTimeout) {
      clearTimeout(this.SearchTimeout);
      this.searchDelay = true;
    }
    if (this.searchDelay) {
      this.searchDelay = false;
      this.SearchTimeout = setTimeout(() => {
        this.ModelChange();
      }, 2500);
    }
    return;
  }


  ModelChange() {


    if (!this.inlineControl) {

      const value = this.model[this.bindValue];

      if (value) {

        let telephone = value.replace(/\D/g, '');

        let isMatch = telephone.match('^\\d{9}$');

        this.isValidationError = !isMatch;
      }
    }

    if (this.ngModelChange) {
      this.ngModelChange.emit();

    }
    if (this.ngValidationError) {
      this.ngValidationError.emit(this.isValidationError);
    }

  }

  onClear() {
    this.model[this.bindValue] = undefined;
    this.changeDetection.detectChanges();
    this.ModelChange();
  }
}
